import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addAward, deleteAward } from '../../../features/playerProfile/playerProfileSlice';
import { CARD, CardTitle, EditButton, BulletList, SECONDARY_BUTTON } from './profileCard';

export const AwardsSection = () => {
  const dispatch = useDispatch();
  const { profile, updateLoading } = useSelector((state) => state.playerProfile);
  const [awards, setAwards] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [newAward, setNewAward] = useState('');

  useEffect(() => {
    if (profile?.awardsAchievements) {
      setAwards(profile.awardsAchievements);
    }
  }, [profile]);

  const handleAddAward = () => {
    if (newAward.trim()) {
      dispatch(addAward(newAward.trim()));
      setNewAward('');
      setIsAdding(false);
    }
  };

  const handleDeleteAward = (award) => {
    if (window.confirm(`Are you sure you want to delete "${award}"?`)) {
      dispatch(deleteAward(award));
    }
  };

  return (
    <section className={`${CARD} min-w-0`}>
      <CardTitle title="Awards & Achievements">
        {!isEditing ? (
          <EditButton onClick={() => setIsEditing(true)}>Edit awards</EditButton>
        ) : (
          <button
            type="button"
            onClick={() => {
              setIsEditing(false);
              setIsAdding(false);
              setNewAward('');
            }}
            className={SECONDARY_BUTTON}
          >
            Done
          </button>
        )}
      </CardTitle>

      {!isEditing ? (
        <BulletList items={awards} empty='No awards yet. Click "Edit awards" to add one.' />
      ) : (
      <div className="flex flex-wrap gap-2">
        {awards.map((award, index) => (
          <div
            key={index}
            className="px-4 py-2 rounded-full bg-jp-accent/10 border border-jp-accent/40 text-jp-accent text-sm font-medium flex items-center gap-2 group"
          >
            <span>{award}</span>
            {isEditing && (
              <button
                onClick={() => handleDeleteAward(award)}
                disabled={updateLoading}
                className="text-red-600 dark:text-red-400 hover:text-red-500 disabled:opacity-50"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                </svg>
              </button>
            )}
          </div>
        ))}

        {/* Add Award Input or Button - Only show when editing */}
        {isEditing && isAdding ? (
          <div className="flex items-center gap-2">
            <input
              type="text"
              value={newAward}
              onChange={(e) => setNewAward(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleAddAward()}
              placeholder="Enter award name"
              className="px-4 py-2 rounded-full bg-jp-section border border-jp-line text-jp-ink text-sm focus:outline-none focus:border-jp-accent"
              autoFocus
              disabled={updateLoading}
            />
            <button
              onClick={handleAddAward}
              disabled={updateLoading || !newAward.trim()}
              className="px-3 py-2 rounded-full bg-cyan-500 hover:bg-cyan-400 text-slate-900 text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
            >
              {updateLoading && (
                <div className="w-3 h-3 mr-1.5 border-2 border-jp-line border-t-transparent rounded-full animate-spin"></div>
              )}
              Add
            </button>
            <button
              onClick={() => {
                setIsAdding(false);
                setNewAward('');
              }}
              disabled={updateLoading}
              className="px-3 py-2 rounded-full bg-jp-section hover:bg-jp-line text-jp-ink text-sm font-medium transition-colors"
            >
              Cancel
            </button>
          </div>
        ) : isEditing ? (
          <button
            onClick={() => setIsAdding(true)}
            disabled={updateLoading}
            className="px-4 py-2 rounded-full border-2 border-dashed border-jp-line text-jp-muted hover:border-jp-accent hover:text-jp-accent text-sm font-medium transition-colors disabled:opacity-50"
          >
            + Add Award
          </button>
        ) : null}
      </div>
      )}
    </section>
  );
};

export default AwardsSection;
